import { Component, OnInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { BaseJwtService } from 'src/app/shared/services/base-jwt.service';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminLayoutComponent implements OnInit {
  isMobileResolution: boolean;

  public aspiranteLogueado: boolean = false;

  constructor
  (
    private _baseJwtService: BaseJwtService
  ) 
  {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    this.aspiranteLogueado = this._baseJwtService.esUsuarioAutenticadoJWT();
  }
  
  @HostListener('window:resize', ['$event'])
  isMobile(event: any) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }
  ngOnInit() {}
}
